module.exports = __webpack_public_path__ + "static/media/icono-bolsas-premium-compradores-ar.d0982764.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icono-bolsas-premium-compradores-ar.png
// module id = 318
// module chunks = 0